import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-file-folder',
    templateUrl: './file-folder.component.html',
    styleUrls: ['../../rendered.component.scss', './file-folder.component.scss'],
    standalone: false
})
export class FileFolderComponent implements OnInit {
  @Input() item;
  @Input() active;
  @Output() navigateItem = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}

  navigate(folder) {
    this.navigateItem.emit(folder);
  }
}
